type Props = {
  open: boolean;
};

export function ToggleButton({ open }: Props) {
  return (
    <span
      aria-hidden
      className="relative block size-[33px] shrink-0 rounded-[2px] bg-[#05f273]"
    >
      <span className="absolute left-1/2 top-1/2 h-[2px] w-4 -translate-x-1/2 -translate-y-1/2 bg-black" />
      {!open && (
        <span className="absolute left-1/2 top-1/2 h-4 w-[2px] -translate-x-1/2 -translate-y-1/2 bg-black" />
      )}
    </span>
  );
}
